import React from 'react'
import { graphql } from "gatsby"
import styled from 'styled-components'
import FrontText from '../../PageComponents/FrontText'
import SEO from '../../seo'
import Layout from '../../layout'
import TopBlock from './TopBlock'
import GridBlock from './GridBlock'
import RestaurantsBlock from './RestaurantsBlock'
import HotelsBlock from './HotelsBlock'


// import Ads from './Ads'

   
class MainPageTemplate extends React.Component {
  render() {
    const { data } = this.props

    // Landing Data Query
    const { html } = data.allMarkdownRemark.edges[0].node
    const { canonical, title, description } = data.allMarkdownRemark.edges[0].node.frontmatter

  
  
  return (
    <Layout >
      <SEO  title={title} canonical={canonical} description={description} />
      <Inner>
        <h1>{title}</h1>     
        <TopBlock />
        {/* <Ads/> */}
        <HotelsBlock/>
        <RestaurantsBlock />
        <GridBlock/>
        <FrontText html={html}/>
     <Partners>
      <div><strong>Partners</strong>: </div>
      <div><a href="https://stackdev.blog" target="_blank">stackdev.blog</a></div>
     </Partners>
      </Inner>
    </Layout>
) 
  } 
}

const Inner = styled.main`
  max-width: ${props => props.theme.maxWidth};
  margin: 0 auto;
  padding: ${props => props.theme.innerPadding};
  @media (max-width: 800px) {
    padding: 2rem;
  }
`; 

const Partners = styled.div`
  strong {
    text-transform: uppercase;
  }
  background-color: #fff;
  border-top: 1px solid #eee;
  font-size: 15px;
  line-height: 1.5;
  padding: 30px 30px 0 0;
  text-align: left;
`;

export default MainPageTemplate


export const pageQuery = graphql`

  query itemsFrontPageQuery($cityName: String!, $cat: String!, $type: String! ) {
    site {
      siteMetadata {
        title,
        siteUrl
      }
    }

    allMarkdownRemark(
      filter: { frontmatter: { type: { eq: $type }, city: { eq: $cityName}, category: {eq: $cat}}}
    ) {
      edges {
          node {
              html
              frontmatter {
                  city
                  category
                  title
                  description
                  canonical
              }
          }
      }
  }

  #   allMongodbTrendymoscowAttractions( 
  #     filter: { city: { eq: $cityName }, category: { eq: $cat } }
  #     sort: { fields: [created], order: DESC }
  #     limit: $limit
  #     skip: $skip
  # ) {
	# 	edges {
  #     node {
  #       name
  #       created
  #       city
  #       slug
  #       titleImage
  #       subway
  #       description
  #       category
  #       location {
  #         address
  #         coordinates
  #       }
  #     }
  #   }
  # }
}
`


